import MessageLuckyBoxImg from '../img/MessageLuckyBoxImg.png';
import TransferImg from '../img/transfer.png';
import LuckyBoxImg from '../img/luckyBox.png';
import DefAvatarIcon from '../icons/defAvatar-icon.svg';
import AvatarAllImg from '../img/avatarAll.png';
import TransferBgEth from '../img/transfer-bg/ETH.png';
import TransferBgTrx from '../img/transfer-bg/TRX.png';
import TransferBgBtc from '../img/transfer-bg/BTC.png';
import TransferBgUni from '../img/transfer-bg/UNI.png';
import EmptyContactImg from './empty-contact-icon.png';
import EmptyGroupImg from './empty-group-icon.png';
import EmptyImg from './empty-icon.png';
import DeleteMyAccountImg from './deleteMyAccount-icon.png';
import DeleteMyAccountNextImg from './deleteMyAccountNext-icon.png';
import EmptyContentImg from './empty-content-icon.png';
import ForbidAddImg from './forbidAdd.png';

const onImageError = (event: React.SyntheticEvent<HTMLImageElement, Event>) => {
  if (event.currentTarget.src !== DefAvatarIcon) {
    event.currentTarget.src = DefAvatarIcon;
  }
};

const MessageLuckyBoxIcon = () => {
  return (
    <img
      className="shake"
      width="100%"
      height="100%"
      src={MessageLuckyBoxImg}
      alt="MessageLuckyBox"
      onError={onImageError}
    />
  );
};

const TransferIcon = () => {
  return <img width="100%" height="100%" src={TransferImg} alt="img" onError={onImageError} />;
};

const LuckyBoxIcon = () => {
  return <img width="100%" height="100%" src={LuckyBoxImg} alt="img" onError={onImageError} />;
};

const AvatarAllIcon = () => {
  return <img width="100%" height="100%" src={AvatarAllImg} alt="img" onError={onImageError} />;
};

const EmptyContactIcon = () => {
  return (
    <img width="100%" height="100%" src={EmptyContactImg} alt="img" onError={onImageError} />
  );
};

const EmptyGroupIcon = () => {
  return <img width="100%" height="100%" src={EmptyGroupImg} alt="img" onError={onImageError} />;
};

const EmptyIcon = () => {
  return <img width="100%" height="100%" src={EmptyImg} alt="img" onError={onImageError} />;
};

const EmptyContentIcon = () => {
  return (
    <img width="100%" height="100%" src={EmptyContentImg} alt="img" onError={onImageError} />
  );
};

const ForbidAddIcon = () => {
  return <img width="100%" height="100%" src={ForbidAddImg} alt="img" onError={onImageError} />;
};
export {
  MessageLuckyBoxIcon,
  TransferIcon,
  LuckyBoxIcon,
  AvatarAllIcon,
  TransferBgEth,
  TransferBgTrx,
  TransferBgBtc,
  TransferBgUni,
  DeleteMyAccountImg,
  DeleteMyAccountNextImg,
  EmptyContactIcon,
  EmptyGroupIcon,
  EmptyIcon,
  EmptyContentIcon,
  ForbidAddIcon,
  // eslint-disable-next-line react-refresh/only-export-components
  onImageError,
};
